<template>
  <div>
    <NuxtPwaManifest />
    <ClientOnly>
      <BasicModal
        v-if="
          showRatingRationale
          && useCurrentStore()?.value?.id != 'e_2879130'
          && !useAppSettingsCookie().value.hasAskedForRating
        "
      >
        <AppPermissionRationale
          :permission-type="'RATING'"
          agree-label="Bewertung abgeben"
          later-label="Feedback abgeben"
          @agreed="sendToAppStore"
          @skipped="sendAppFeedback"
          @closed="showRatingRationale = !showRatingRationale"
        />
      </BasicModal>
      <div v-if="dialog != 'NONE'">
        <AppLogin
          v-if="dialog == 'LOGIN'"
          @close-login="dialog = 'NONE'"
          @open-register="dialog = 'REGISTER'"
          @back-to-intro="dialog = 'INTRO'"
          @navigate-modal="navigateAppModal"
        />
        <AppStoreAssignment
          v-if="dialog == 'STOREFINDER'"
          @close-dialog="dialog = 'NONE'"
          @navigate-modal="navigateAppModal"
        />
        <AppRegister
          v-if="dialog == 'REGISTER'"
          @close-intro="dialog = 'NONE'"
          @back-to-login="dialog = 'LOGIN'"
          @navigate-modal="navigateAppModal"
        />
        <AppPasswordRecover
          v-if="dialog == 'PASSWORDRECOVER'"
          @back-to-login="dialog = 'LOGIN'"
          @navigate-modal="navigateAppModal"
        />
      </div>
    </ClientOnly>
    <div v-if="dialog == 'NONE'">
      <LayoutAppHeader v-if="!isEmbedded" />
      <main class="app pb-[100px]" :class="basisPaybackFeature && useCurrentStore().value?.paybackStore ? 'pt-[160px]':'pt-[135px]'">
        <slot />
      </main>
      <BasicBtErrorBoundary>
        <BtDevOnly>
          <p>Version Info:</p>
          <pre>{{ useRuntimeConfig().public.version }}</pre>
          <p>Feature State:</p>
          <pre>
            {{ useFlagsUsedState()?.value }}
          </pre>
        </BtDevOnly>
      </BasicBtErrorBoundary>
      <BasicBtErrorBoundary>
        <LayoutAppFooter
          v-if="!isEmbedded"
          @navigate-modal="navigateAppModal"
        />
      </BasicBtErrorBoundary>
    </div>
  </div>
</template>

<script setup lang="ts">
import { useCurrentStore, useAppSettingsCookie } from '~/composables/states';
import { sendToAppStore, sendAppFeedback } from '~/composables/miscFunctions';
const { $pwa } = useNuxtApp();
const showRatingRationale = useState('showRatingRationale', () => false);

const isEmbedded = useEmbedded();

if ($pwa?.needRefresh || $pwa?.registrationError) {
  console.warn('updating service worker');
  await $pwa.updateServiceWorker(true);
}

const dialog = ref('NONE');
const featureStatePayback = computed(() => useFeatureState('exsi-1556') && useCurrentStore().value.paybackStore);
const basisPaybackFeature = computed(
  () =>
    featureStatePayback.value
    && (useFeatureValue('exsi-1556').value?.name == 'basic'
      || useFeatureValue('exsi-1556').value?.name == 'redemption'
      || useFeatureValue('exsi-1556').value?.name == 'full')
);

const route = useRoute();
const allowTheme = computed(() => {
  return route.path.endsWith('/app') || route.path.endsWith('/app/');
});

definePageMeta({
  disableTheme: allowTheme,
});

watchEffect(async () => {
  if (useCurrentStore()?.value?.id != 'e_2879130') {
    dialog.value = 'NONE';
  } else {
    if (useRoute().fullPath.includes('app/Golf/EXP-TG')) {
      const fmarktcookie = useCookie('fmarktcookie');
      fmarktcookie.value = 'e_18271100';
    } else {
      dialog.value = 'STOREFINDER';
    }
  }
});

onNuxtReady(() => {
  try {
    setABContextVariable('isappuser', true);
  } catch (error) {
    console.error('could not set context value', error);
  }
  if (useRoute()?.query?.showRatingRationale == 'true') {
    showRatingRationale.value = true;
  }
});

useAppConfig().homelink = '/app';

const navigateAppModal = (n: string) => {
  dialog.value = n || 'NONE';
};
</script>

<style lang="postcss">
.app-main {
  padding-bottom: 100px;
}
</style>
